// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__HPdEO"};